<template>
  <div class="col-4">
    <slot />
  </div>
</template>
